module.exports = __webpack_public_path__ + "static/media/gift.75762d0e.png";